import { useGetChatsOrderByMessagesCountAsAdminQuery } from "../../../lib/apollo/graphql/generated";
import BoxWithShadow from "../../common/components/BoxWithShadow";
import { TrophyIcon } from "@heroicons/react/24/solid";
import { formatDate } from "../../../utilities/format";
import Loader from "../../common/components/Loader";
import { cva } from "class-variance-authority";

export default function ChatRankingBoard() {
  const { data, loading } = useGetChatsOrderByMessagesCountAsAdminQuery({
    variables: {
      first: 50,
    },
  });

  const chats = data?.getChatsOrderByMessagesCountAsAdmin.edges || [];

  if (loading) {
    return (
      <BoxWithShadow className="gap-3">
        <p className="text-lg font-bold">채팅 Top 50</p>
        <Loader />
      </BoxWithShadow>
    );
  }

  return (
    <BoxWithShadow className="gap-3">
      <p className="text-lg font-bold">채팅 Top 50</p>
      <div className="flex flex-col gap-3 overflow-y-auto">
        {chats?.map((chat, index) => {
          const chatVariant = (() => {
            if (index === 0) {
              return "first";
            } else if (index === 1) {
              return "second";
            } else if (index === 2) {
              return "third";
            } else {
              return "unranked";
            }
          })();

          return (
            <div className={itemStyles({ variant: chatVariant })} key={chat.id}>
              <div className="flex items-center justify-between">
                <span>
                  <strong>{chat?.receiver?.name} 수급자님</strong>의 채팅방
                </span>
                {index <= 2 && (
                  <TrophyIcon
                    className={trophyStyles({ variant: chatVariant })}
                  />
                )}
              </div>
              <span className="text-xl font-bold text-slate-700">
                총 {chat?.messageCount}회
              </span>
              <span className="mt-3 text-sm">
                최근 채팅: {formatDate(chat?.updatedAt, "YY/MM/DD HH시 mm분")}
              </span>
            </div>
          );
        })}
      </div>
    </BoxWithShadow>
  );
}

const itemStyles = cva(
  "relative flex flex-col gap-1 rounded-md px-3 py-5 text-zinc-700",
  {
    variants: {
      variant: {
        first: "border border-amber-500 bg-amber-50",
        second: "border border-zinc-500 bg-zinc-50",
        third: "border border-amber-700 bg-amber-700/5",
        unranked: "border border-zinc-300",
      },
    },
    defaultVariants: {
      variant: "unranked",
    },
  }
);

const trophyStyles = cva("h-5 w-5", {
  variants: {
    variant: {
      first: "text-amber-500",
      second: "text-zinc-500",
      third: "text-amber-900",
      unranked: "",
    },
  },
});
